/* eslint-disable spire/export-styles */
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import * as React from "react";
import { connect } from "react-redux";

const enum fields {
    className = "className",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.className]: string;
    };
}

export interface PageTitleStyles {
    title?: TypographyPresentationProps;
}

const pageTitleStlyes: PageTitleStyles = {
    title: {
        fontFamily: "OpenSansBold",
        size: "2.25em",
    },
};

const mapStateToProps = (state: ApplicationState) => ({
    pageTitle: getCurrentPage(state).fields.title,
});

type Props = OwnProps & WidgetProps & ReturnType<typeof mapStateToProps>;

const styles = pageTitleStlyes;

const PageTitle: React.FunctionComponent<Props> = ({ pageTitle, fields }: Props) => (
    <Typography variant="h3" as="h1" data-test-selector="PageTitle" {...styles.title} className={fields.className}>
        {fields.overrideTitle || pageTitle}
    </Typography>
);

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(PageTitle),
    definition: {
        group: "Basic",
        icon: "heading",
        fieldDefinitions: [
            {
                name: fields.className,
                displayName: "ClassName",
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "Translatable",
            },
        ],
    },
};

export default widgetModule;
